export enum EQueryKeys {
    ORDER = "order",
    BUNDLES = "bundles",
    BUNDLE = "bundle",
    PAYPAL = "paypal"
}